/* eslint-disable react/prop-types */
import React from "react";
import { Link } from "react-router-dom";
import { Card, Tag, Col } from "antd";
import statusColor from "../../components/utils/satus";

const { Meta } = Card;

const thumbWrapStyle = {
  position: "relative",
  width: "100%",
  aspectRatio: "16 / 9",
  overflow: "hidden",
  background: "var(--vc-border)",
};

const thumbImgStyle = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
};

function Cover({ item }) {
  return (
    <div style={thumbWrapStyle}>
      <img
        alt=""
        src={
          item.photo_url ||
          "https://images.unsplash.com/photo-1440404653325-ab12749ad9e4?w=800&q=80"
        }
        style={thumbImgStyle}
      />
    </div>
  );
}

/**
 * Read-only project card for the demo route.
 * Live samples link to `/demo/project/:uid`; others are static cards.
 */
const DemoFilmCard = ({ item }) => {
  const isLive = item.distributionStatus === "live";
  const meta = (
    <Meta
      title={item.title}
      description={
        <Tag
          color={
            (statusColor[item.distributionStatus] &&
              statusColor[item.distributionStatus].color) ||
            "warning"
          }
          icon={
            statusColor[item.distributionStatus] &&
            statusColor[item.distributionStatus].icon
          }
        >
          {item.distributionStatus || "—"}
        </Tag>
      }
    />
  );

  if (isLive) {
    return (
      <Col xs={{ span: 24 }} lg={{ span: 6 }} style={{ padding: 8 }}>
        <Link to={`/demo/project/${item.uid}`}>
          <Card
            hoverable
            cover={<Cover item={item} />}
            style={{ width: "100%", marginBottom: 24 }}
          >
            {meta}
          </Card>
        </Link>
      </Col>
    );
  }

  return (
    <Col xs={{ span: 24 }} lg={{ span: 6 }} style={{ padding: 8 }}>
      <Card
        cover={<Cover item={item} />}
        style={{ width: "100%", marginBottom: 24 }}
      >
        {meta}
      </Card>
    </Col>
  );
};

export default DemoFilmCard;
